// extracted by mini-css-extract-plugin
export var content = "_cb-3";
export var list = "_cb-4";
export var settingsContent = "_cb-7";
export var settingsPanel = "_cb-8";
export var state = "_cb-6";
export var triggerBadge = "_cb-2";
export var triggerButton = "_cb-1";
export var triggerShell = "_cb-0";
export var unreadDot = "_cb-5";